<script>
    import ClinicRestoreDialog from "@dialogs/admin/settings/tools/ClinicRestoreDialog"
    import UpdateUrlDialog from "@dialogs/admin/settings/tools/UpdateUrlDialog"
    import ExportBitrixDialog from "@dialogs/admin/settings/tools/ExportBitrixDialog"
    import ExportDoctorsDialog from "@dialogs/admin/settings/tools/ExportDoctorsDialog"
    import ConnectWithCrmDialog from "@dialogs/admin/settings/tools/ConnectWithCrmDialog"
    import ImportCompetitorsDialog from "@dialogs/admin/settings/tools/ImportCompetitorsDialog"
    import UserRestoreDialog from "@dialogs/admin/settings/tools/UserRestoreDialog"
    import UpdateClinicElasticDialog from "@dialogs/admin/settings/tools/UpdateClinicElasticDialog"
    import SearchInDoctorFeedsDialog from "@dialogs/admin/settings/tools/SearchInDoctorFeeds/SearchDialog"
    import SettingsTokenSberDialog from "@dialogs/admin/settings/tools/SettingsTokenSberDialog"

    export default {
        components: {
            UpdateUrlDialog,
            ExportBitrixDialog,
            ClinicRestoreDialog,
            ConnectWithCrmDialog,
            ImportCompetitorsDialog,
            UserRestoreDialog,
            UpdateClinicElasticDialog,
            ExportDoctorsDialog,
            SearchInDoctorFeedsDialog,
            SettingsTokenSberDialog
        },
        data: () => ({
            updateUrlModal: false,
            buttonsDisabled: {
                updateMetros: false,
                updateSearchMetros: false,
            }
        }),
        props: {
            cityOptions: {
                required: true,
                type: Array,
            },
            clinicSearchMetrosUpdating: {
                type: Boolean,
                default: false,
            },
            clinicMetrosUpdating: {
                type: Boolean,
                default: false,
            },
        },
        methods: {
            showUpdateUrlModal() {
                this.$refs.updateUrlDialog.show();
            },
            showClinicRestoreModal() {
              this.$refs.clinicRestoreDialog.show();
            },
            showImportCompetitorsModal() {
                this.$refs.importCompetitorsDialog.show();
            },
            showUserRestoreModal() {
                this.$refs.userRestoreDialog.show();
            },
            showUpdateClinicElasticModal() {
                this.$refs.updateClinicElasticDialog.show();
            },
            showSearchInDoctorFeedsModal() {
                this.$refs.searchInDoctorFeedsDialog.show();
            },
            async showSettingsTokenSberModal() {
                await this.$refs.settingsTokenSberDialog.show();
            },
            updateClinicMetros() {
                this.buttonsDisabled.updateMetros = true
                this.axios
                    .post('/admin/settings/tools/updateClinicMetros')
                    .then((response) => {
                        this.this.checkMetrosProgress();
                    })
            },
            updateClinicSearchMetros() {
                this.buttonsDisabled.updateSearchMetros = true
                this.axios
                    .post('/admin/settings/tools/updateClinicSearchMetros')
                    .then((response) => {
                        this.checkMetrosProgress();
                    })
            },
            exportBitrix() {
                this.$refs.exportBitrixDialog.show();
            },
            exportDoctors(){
                this.$refs.exportDoctorsDialog.show();
            },
            checkMetrosProgress() {
                let scope = this;

                const interval = setInterval(function () {
                    scope.axios.post('/admin/settings/tools/isMetrosUpdating', {}).then(response => {
                        scope.buttonsDisabled.updateSearchMetros = response.data.clinicSearchMetrosUpdating;
                        scope.buttonsDisabled.updateMetros = response.data.clinicMetrosUpdating;

                        if (!scope.buttonsDisabled.updateSearchMetros && !scope.buttonsDisabled.updateMetros) {
                            clearInterval(interval);
                        }
                    });
                }, 5000);
            },
            connectWithCrm() {
                this.$refs.connectWithCrmDialog.show();
            },
        },
        created() {
            this.buttonsDisabled.updateSearchMetros = this.clinicSearchMetrosUpdating;
            this.buttonsDisabled.updateMetros = this.clinicMetrosUpdating;

            if (this.buttonsDisabled.updateSearchMetros || this.buttonsDisabled.updateMetros) {
                this.checkMetrosProgress();
            }
        }
    }
</script>

<template>
    <div>
        <update-url-dialog ref="updateUrlDialog" />
        <clinic-restore-dialog ref="clinicRestoreDialog" />
        <export-bitrix-dialog ref="exportBitrixDialog" :city-options="cityOptions" />
        <export-doctors-dialog ref="exportDoctorsDialog"/>
        <connect-with-crm-dialog ref="connectWithCrmDialog" />
        <import-competitors-dialog ref="importCompetitorsDialog" />
        <user-restore-dialog ref="userRestoreDialog" />
        <update-clinic-elastic-dialog ref="updateClinicElasticDialog"/>
        <search-in-doctor-feeds-dialog ref="searchInDoctorFeedsDialog"/>
        <settings-token-sber-dialog ref="settingsTokenSberDialog"/>

        <main id="mainCtrl" v-if="$can('admin.settings.tools.*')">
            <table v-cloak class="_scoped">
                <colgroup>
                    <col style="width:50%">
                    <col style="width:50%">
                </colgroup>
                <tr>
                    <td><button @click="exportBitrix">CSV выгрузка клиники в Битрикс24</button></td>
                    <td><button @click="connectWithCrm">Связать с CRM</button></td>
                </tr>
              <tr>
                <td><button @click="showUpdateUrlModal">Заменить URL</button></td>
                <td><button @click="showClinicRestoreModal">Восстановить клинику по URL</button></td>
              </tr>
                <tr>
                    <td>
                        <button @click="updateClinicSearchMetros"
                                width="100%"
                                :disabled="buttonsDisabled.updateSearchMetros">
                            Проставить метро для ПОИСКА{{ buttonsDisabled.updateSearchMetros ? ' (в процессе...)' : '' }}
                        </button>
                    </td>
                    <td>
                        <button @click="updateClinicMetros"
                                width="100%"
                                :disabled="buttonsDisabled.updateMetros">
                            Проставить метро для АНКЕТ{{ buttonsDisabled.updateMetros ? ' (в процессе...)' : '' }}
                        </button>
                    </td>
                </tr>
                <tr>
                    <td><button @click="showImportCompetitorsModal">Импорт URL конкурентов</button></td>
                    <td><button @click="showUserRestoreModal">Восстановить юзера по логину</button></td>
                </tr>
                <tr>
                    <td>
                        <button @click="showUpdateClinicElasticModal">
                            Обновить данные о клинике в Эластике
                        </button>
                    </td>
                    <td>
                        <button @click="showSearchInDoctorFeedsModal">
                            Поиск по фидам врачей для Яндекса
                        </button>
                    </td>
                </tr>
                <tr>
                    <td>
                        <button @click="exportDoctors"
                                width="100%">
                            Выгрузить врачей клиники
                        </button>
                    </td>
                    <td>
                        <button @click="showSettingsTokenSberModal"
                                width="100%">
                            Токен авторизации Сбер
                        </button>
                    </td>
                </tr>
            </table>
        </main>
    </div>
</template>
<style scoped>
    ._scoped, ._scoped button {
        width:100%;
    }
    ._scoped td {
        padding:5px;
    }
</style>
